import { PhoneMask } from './phone-masks';
import { InjectionToken } from '@angular/core';

export const PHONE_INPUT_MASKS = new InjectionToken<PhoneMask[]>('phone.mask');
